var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
function withErrorBoundary(WrappedComponent, ErrorComponent, errorCallback) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(WithErrorBoundary, _super);
            function WithErrorBoundary(props) {
                var _this = _super.call(this, props) || this;
                _this.state = {
                    error: null,
                    errorInfo: null,
                    hasError: false,
                };
                return _this;
            }
            WithErrorBoundary.prototype.componentDidCatch = function (error, info) {
                this.setState({
                    error: error,
                    errorInfo: info,
                    hasError: true,
                });
                if (typeof errorCallback !== 'undefined') {
                    errorCallback(error, info, this.props);
                }
            };
            WithErrorBoundary.prototype.render = function () {
                var _a = this.state, error = _a.error, errorInfo = _a.errorInfo, hasError = _a.hasError;
                if (hasError) {
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    return React.createElement(ErrorComponent, __assign({}, this.props, { error: error, errorInfo: errorInfo }));
                }
                // eslint-disable-next-line react/jsx-props-no-spreading
                return React.createElement(WrappedComponent, __assign({}, this.props));
            };
            return WithErrorBoundary;
        }(Component)),
        // eslint-disable-next-line react/static-property-placement
        _a.displayName = "withErrorBoundary(" + (WrappedComponent.displayName || WrappedComponent.name) + ")",
        _a;
}
export default withErrorBoundary;
//# sourceMappingURL=index.js.map